import { DefaultValues } from '@Enum/DefaultValues.enum';
import { RequestFormHeader, RequisitionInfo, TypeDict } from '@Types/index';
import dayjs from 'dayjs';
import { parseDateTime } from './transformDateTime';

const { REQUISITION_STATUS_DEFAULT } = DefaultValues;

const prepareRequisitionStatus = (
  requestFormData: RequestFormHeader,
  requestStatuses: TypeDict[]
): string => {
  if (!requestFormData.reqStatusId) {
    return REQUISITION_STATUS_DEFAULT;
  }

  const matchedStatusDesc = requestStatuses.find(
    (status) => status.codeNum === requestFormData.reqStatusId
  )?.codeDesc;
  return matchedStatusDesc || REQUISITION_STATUS_DEFAULT;
};

const prepareRequisitionDate = (requestFormData: RequestFormHeader): string => {
  let date = requestFormData.createdDate;

  if (!date) {
    const now = dayjs().toISOString();
    date = now;
  }

  const formattedDate = parseDateTime(date);
  return formattedDate;
};

export const prepareRequisitionInfo = (
  requestFormData: RequestFormHeader,
  requestStatuses: TypeDict[],
  type: 'ESS' | 'MR' = 'ESS'
): RequisitionInfo => {
  let requisitionNo: string | number;

  if (type === 'MR' && requestFormData.requisitionNo) {
    requisitionNo = requestFormData.requisitionNo;
  } else {
    requisitionNo = requestFormData.requestId;
  }

  const requisitionStatus = prepareRequisitionStatus(
    requestFormData,
    requestStatuses
  );
  const requisitionDate = prepareRequisitionDate(requestFormData);

  const requisitionInfo = {
    requisitionNo,
    requisitionStatus,
    requisitionDate,
  };

  return requisitionInfo;
};
